/**
 * Presentation bits shared by every surface that shows a driver offer: the home
 * card and the full-screen offer. One copy, so the two cannot drift.
 */

/** Every offer InGo makes a rider is a delivery. */
export const OFFER_KIND_LABEL = 'Delivery';

export function OfferPinPickup() {
  return (
    <svg className="offerPin" viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M12 21s7-4.35 7-10a7 7 0 1 0-14 0c0 5.65 7 10 7 10Z"
        fill="rgba(var(--ingo-primary-rgb), 0.15)"
        stroke="var(--ingo-primary)"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="11" r="2.2" fill="var(--ingo-primary)" />
    </svg>
  );
}

export function OfferPinDrop() {
  return (
    <svg className="offerPin" viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M12 21s7-4.35 7-10a7 7 0 1 0-14 0c0 5.65 7 10 7 10Z"
        fill="var(--ingo-danger-soft)"
        stroke="var(--ingo-danger)"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="11" r="2.2" fill="var(--ingo-danger)" />
    </svg>
  );
}
